import type { LogsEvent } from '@datadog/browser-logs';

import { generateGroupingKey } from '@eluve/datadog-error-queries';

/**
 * Datadog browser-logs `beforeSend` hook that tags error/warn logs with a
 * normalized `errorGroup` (ENG-4881) — the same key the api-nest logger and
 * the unknown-error digest use, so the dashboard's by-group breakdown lines up
 * across services. Mutating custom attributes in place is supported by the SDK.
 *
 * Typed by the single arg it uses (the SDK's `beforeSend` option accepts a
 * function with fewer params), so callers/tests don't pass an unused context.
 * Returns true — error/warn logs are tagged, never dropped.
 */
export const errorGroupBeforeSend = (event: LogsEvent): boolean => {
  if (event.status === 'error' || event.status === 'warn') {
    event['errorGroup'] = generateGroupingKey(event.message);
  }
  return true;
};
